import React from 'react';
import { SVGIconProps } from '../../domains/common';

const GoogleAddsIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 2442.4 2237"
      fill="none"
      {...rest}
    >
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M50.4,1628.6L862.5,221.9l703.7,406.3L754.2,2034.9L50.4,1628.6z"
          fill={colored ? '#FBBC04' : '#4E7BB7'}
        />
        <path
          d="M2385.1,1623.7L1572.5,216.5C1467.6,18.1,1221.8-57.7,1023.4,47.2S749.3,397.9,854.1,596.3   c4.6,8.7,9.5,17.2,14.7,25.6l812.6,1407.2c109.6,195.8,357.2,265.7,553,156.1c195.8-109.6,265.7-357.2,156.1-553   c-1.8-3.2-3.6-6.3-5.4-9.4L2385.1,1623.7L2385.1,1623.7z"
          fill={colored ? '#4285F4' : '#365284'}
        />
        <circle
          cx="406.3"
          cy="1828.6"
          r="406.3"
          fill={colored ? '#34A853' : '#365284'}
        />
      </g>
    </svg>
  );
};

export default GoogleAddsIcon;
